// AUTO-GENERATED — do not edit by hand. Source: world-countries-centroids (gavinr).
// ISO 3166-1 alpha-2 → [longitude, latitude] of the country centroid, in degrees. Cloudflare's
// clientCountryName dimension is an alpha-2 code; the map plots a bubble at the matching centroid.
// Country display names come from Intl.DisplayNames('fr') and flags from the code — no table needed.
export const COUNTRY_CENTROIDS: Record<string, readonly [number, number]> = {
  AD: [1.58, 42.549],
  AE: [54.279, 24.183],
  AF: [66.592, 34.134],
  AG: [-61.785, 17.071],
  AI: [-63.06, 18.223],
  AL: [20.061, 41.142],
  AM: [45.055, 40.178],
  AO: [17.652, -12.167],
  AQ: [-177.565, -77.17],
  AR: [-64.532, -35.697],
  AS: [-170.701, -14.306],
  AT: [13.798, 47.632],
  AU: [134.023, -25.697],
  AW: [-69.976, 12.516],
  AZ: [48.635, 40.392],
  BA: [17.835, 44.144],
  BB: [-59.557, 13.183],
  BD: [90.432, 23.674],
  BE: [4.675, 50.618],
  BF: [-1.693, 12.109],
  BG: [25.252, 42.82],
  BH: [50.541, 26.048],
  BI: [29.885, -3.261],
  BJ: [2.306, 9.503],
  BL: [-62.831, 17.906],
  BM: [-64.746, 32.315],
  BN: [114.643, 4.543],
  BO: [-64.452, -16.731],
  BQ: [-62.978, 17.492],
  BR: [-54.355, -11.525],
  BS: [-78.073, 24.722],
  BT: [90.467, 27.422],
  BV: [3.412, -54.423],
  BW: [23.858, -22.237],
  BY: [27.964, 53.468],
  BZ: [-88.683, 17.243],
  CA: [-98.417, 57.55],
  CC: [96.837, -12.171],
  CD: [23.42, -3.339],
  CF: [20.521, 6.331],
  CG: [14.88, -0.729],
  CH: [8.287, 46.737],
  CI: [-5.572, 7.537],
  CK: [-159.788, -21.223],
  CL: [-70.769, -37.829],
  CM: [12.948, 6.294],
  CN: [104.691, 38.073],
  CO: [-72.645, 4.188],
  CR: [-84.147, 9.863],
  CU: [-79.698, 21.476],
  CV: [-23.634, 15.076],
  CW: [-68.969, 12.2],
  CX: [105.702, -10.446],
  CY: [33.375, 35.117],
  CZ: [15.383, 49.749],
  DE: [10.426, 51.083],
  DJ: [42.613, 11.75],
  DK: [9.379, 56.001],
  DM: [-61.36, 15.429],
  DO: [-70.435, 18.78],
  DZ: [2.656, 28.351],
  EC: [-78.463, -1.564],
  EE: [25.917, 58.648],
  EG: [30.24, 26.605],
  ER: [39.267, 15.006],
  ES: [-16.538, 28.298],
  ET: [39.915, 8.729],
  FI: [25.657, 65.016],
  FJ: [177.981, -17.822],
  FK: [-58.747, -51.759],
  FM: [158.229, 6.879],
  FO: [-6.981, 62.131],
  FR: [2.194, 46.642],
  GA: [11.839, -0.628],
  GB: [-2.853, 53.978],
  GD: [-61.679, 12.113],
  GE: [43.379, 42.18],
  GF: [-53.322, 3.857],
  GG: [-2.576, 49.459],
  GH: [-1.219, 7.945],
  GI: [-5.346, 36.14],
  GL: [-42.076, 74.168],
  GM: [-15.383, 13.429],
  GN: [-10.987, 10.256],
  GP: [-61.544, 16.244],
  GQ: [10.425, 1.595],
  GR: [23.11, 39.42],
  GS: [-36.775, -54.377],
  GT: [-90.312, 15.821],
  GU: [144.78, 13.445],
  GW: [-14.98, 11.98],
  GY: [-58.914, 4.682],
  HM: [73.493, -53.084],
  HN: [-86.493, 14.74],
  HR: [16.626, 44.912],
  HT: [-72.893, 18.884],
  HU: [19.396, 47.225],
  ID: [113.965, 0.156],
  IE: [-8.241, 53.305],
  IL: [35.028, 31.514],
  IM: [-4.533, 54.229],
  IN: [81.173, 23.586],
  IO: [72.435, -7.324],
  IQ: [43.833, 33.105],
  IR: [54.237, 32.906],
  IS: [-19.057, 65.124],
  IT: [12.764, 42.982],
  JE: [-2.129, 49.215],
  JM: [-77.304, 18.122],
  JO: [36.957, 31.387],
  JP: [137.469, 36.767],
  KE: [37.953, 0.69],
  KG: [74.175, 41.357],
  KH: [105.04, 12.699],
  KI: [-157.39, 1.868],
  KM: [43.348, -11.659],
  KN: [-62.746, 17.315],
  KP: [127.338, 40.192],
  KR: [127.762, 36.402],
  KW: [47.563, 29.281],
  KY: [-81.252, 19.311],
  KZ: [66.376, 47.641],
  LA: [103.764, 18.117],
  LB: [35.897, 33.912],
  LC: [-60.969, 13.896],
  LI: [9.548, 47.146],
  LK: [80.669, 7.697],
  LR: [-9.259, 6.52],
  LS: [28.245, -29.602],
  LT: [23.946, 55.294],
  LU: [6.103, 49.775],
  LV: [24.694, 56.814],
  LY: [17.911, 27.203],
  MA: [-8.817, 28.688],
  MC: [7.413, 43.748],
  MD: [28.391, 47.073],
  ME: [19.295, 42.737],
  MF: [-63.067, 18.078],
  MG: [46.685, -19.042],
  MH: [168.72, 7.308],
  MK: [21.71, 41.594],
  ML: [-4.346, 17.168],
  MM: [97.089, 19.901],
  MN: [103.399, 47.086],
  MP: [145.741, 15.178],
  MQ: [-61.014, 14.643],
  MR: [-10.495, 20.467],
  MS: [-62.187, 16.735],
  MT: [14.442, 35.891],
  MU: [57.564, -20.281],
  MV: [73.101, -0.607],
  MW: [34.234, -13.129],
  MX: [-101.554, 23.874],
  MY: [114.633, 3.672],
  MZ: [35.209, -17.525],
  NA: [18.165, -21.909],
  NC: [165.508, -21.33],
  NE: [8.869, 17.081],
  NF: [167.953, -29.038],
  NG: [8.148, 9.61],
  NI: [-85.016, 12.894],
  NL: [5.554, 52.134],
  NO: [16.67, 64.978],
  NP: [84.134, 28.301],
  NR: [166.929, -0.522],
  NU: [-169.869, -19.052],
  NZ: [170.69, -43.828],
  OM: [55.841, 20.724],
  PA: [-80.144, 8.44],
  PE: [-74.114, -8.523],
  PF: [-149.4, -17.675],
  PG: [144.835, -7.157],
  PH: [121.822, 15.587],
  PK: [69.088, 30.116],
  PL: [19.436, 52.068],
  PM: [-56.325, 46.952],
  PN: [-128.315, -24.366],
  PR: [-66.494, 18.216],
  PS: [35.243, 31.931],
  PT: [-7.934, 39.675],
  PW: [134.58, 7.535],
  PY: [-58.389, -23.422],
  QA: [51.198, 25.319],
  RE: [55.544, -21.12],
  RO: [25.094, 45.825],
  RS: [20.857, 44.027],
  RU: [98.67, 59.039],
  RW: [29.919, -2.015],
  SA: [44.601, 24.136],
  SB: [160.165, -9.613],
  SC: [55.473, -4.66],
  SD: [29.951, 15.671],
  SE: [17.062, 62.734],
  SG: [103.81, 1.353],
  SH: [-5.717, -15.963],
  SI: [14.891, 46.138],
  SJ: [16.036, 78.573],
  SK: [19.581, 48.698],
  SL: [-11.787, 8.561],
  SM: [12.461, 43.943],
  SN: [-14.611, 14.229],
  SO: [45.4, 6.525],
  SR: [-55.856, 4.099],
  SS: [30.385, 7.658],
  ST: [6.606, 0.227],
  SV: [-88.859, 13.758],
  SX: [-63.069, 18.039],
  SY: [38.512, 35.098],
  SZ: [31.511, -26.563],
  TC: [-71.741, 21.8],
  TD: [18.427, 15.283],
  TF: [47.291, -11.566],
  TG: [0.899, 8.661],
  TH: [101.087, 13.662],
  TJ: [70.942, 38.569],
  TK: [-171.853, -9.195],
  TL: [125.95, -8.81],
  TM: [58.458, 39.061],
  TN: [9.656, 34.086],
  TO: [-175.204, -21.159],
  TR: [35.569, 38.932],
  TT: [-61.372, 10.416],
  TV: [179.218, -8.515],
  TZ: [34.818, -6.356],
  UA: [31.274, 48.658],
  UG: [32.344, 1.282],
  UM: [166.638, 19.302],
  US: [-96.332, 38.821],
  UY: [-56.019, -32.782],
  UZ: [63.855, 41.488],
  VA: [12.451, 41.904],
  VC: [-61.194, 13.255],
  VE: [-66.365, 7.148],
  VG: [-64.624, 18.422],
  VI: [-64.762, 17.738],
  VN: [105.913, 16.517],
  VU: [166.849, -15.189],
  WF: [-178.127, -14.283],
  WS: [-172.441, -13.634],
  YE: [47.468, 16.001],
  YT: [45.128, -12.824],
  ZA: [24.753, -28.554],
  ZM: [27.755, -13.163],
  ZW: [29.718, -18.927]
};
